export enum Domain {
  Realm = 'realm',
  Stitch = 'stitch',
}
